import * as React from 'react'
import { useMutation } from 'react-query'
import postOrderCancel from '../queries/PostOrderCancelQuery'

const usePostOrderCancel = () => {
    const { mutate, data, error, isLoading, isSuccess, isError } = useMutation(
        'postOrderCancel',
        postOrderCancel
    )

    return { mutate, data, error, isLoading, isSuccess, isError }
}

export default usePostOrderCancel
